import React, { useRef, useEffect } from "react";
import ClientTalkCard from "./ClientTalkCard";
// import Swiper core and required modules
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay
} from "swiper/core";

import { Swiper, SwiperSlide } from "swiper/react";
import { useSwiperArrows } from "../../lib/hooks/useSwiperArrows";

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

const ClientsTalk = () => {
  const slider_items = [
    {
      title: "Babji Neelam",
      designation: "Founder & CEO – Technical Hub",
      desc: "Sai Chandu consistently shows great dedication, problem-solving skills, and a proactive approach, making him a valuable asset in delivering successful projects.",
      src: "/Images/Mentors/BabjiSir.jpeg",
   },   
    {
      title: "K.V.SATYANARAYANA",
      designation: "Technical Events Lead - Aditya University",
      desc: `Sai Chandu efficiently translated complex requirements into a smooth, functional system. His work added significant value to the Veda project.`,
      src: "/Images/Clients/SATYANARAYANA.jpeg",
    },
    {
      title: "SIVA KANTH SATTIRAJU",
      designation: "Technical Lead - Cisco",
      desc: `Sai Chandu was crucial in developing Matrix, ensuring smooth AI model integration. His technical expertise and proactive approach drove the project’s success.`,
      src: "/Images/Clients/SIVA KANTH SATTIRAJU.jpeg",
    },
    {
      title: "P.B.S.J. CHAKRAVARTHI",
      designation: "Campus Incharge - Aditya University",
      desc: `Sai Chandu developed a reliable tracking system for Late Comers, ensuring real-time data handling. His attention to detail and professionalism were key to its success.`,
      src: "/Images/Clients/CHAKRAVARTHI.jpg",
    },
  ];

  const swiper_settings = {
    spaceBetween: 20,
    slidesPerView: 1,
    loop: true,
    speed: 1000,
    autoplay: { 
      delay: 3000, 
      disableOnInteraction: false 
    },
    breakpoints: {
      // Mobile first approach - start with smallest screen
      320: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      480: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      576: {
        slidesPerView: 1.5,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 2.5,
        spaceBetween: 25,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  };

  const { sliderRef, toNext, toPrev } = useSwiperArrows();
  const paginationRef = useRef(null);

  // Handle window resize for better responsiveness
  useEffect(() => {
    const handleResize = () => {
      if (sliderRef.current) {
        sliderRef.current.update();
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <section className="testimonial-area-three">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-8 col-sm-12">
            <div className="section-title title-style-two white-title mb-45">
              <h2 className="title">
                Some Words From <br className="d-none d-md-block" />
                My Clients
              </h2>
            </div>
          </div>

          <div className="col-md-4 col-sm-12">
            <div className="testimonial-nav">
              <button className="swiper-button-prev" onClick={toPrev} />
              <button className="swiper-button-next" onClick={toNext} />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div className="swiper-container testimonial-active-three">
              <div className="swiper-wrapper">
                <Swiper
                  {...swiper_settings}
                  onBeforeInit={(swiper) => {
                    sliderRef.current = swiper;
                  }}
                  pagination={{
                    el: paginationRef.current,
                    clickable: true,
                    dynamicBullets: true,
                  }}
                >
                  {/* Duplicating the items to ensure smooth infinite scrolling */}
                  {[...slider_items, ...slider_items].map((item, index) => (
                    <SwiperSlide key={`slide-${index}`}>
                      <ClientTalkCard 
                        title={item.title}
                        designation={item.designation}
                        desc={item.desc}
                        src={item.src}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          </div>
        </div>

        <div className="testimonial-swiper-pagination" ref={paginationRef}></div>
      </div>

      <div className="testimonial-shape-wrap">
        <img src="/img/images/testimonial_shape01.png" alt="" className="shape-1 d-none d-md-block" />
        <img src="/img/images/testimonial_shape02.png" alt="" className="shape-2 d-none d-lg-block" />
        <img src="/img/images/testimonial_shape03.png" alt="" className="shape-3 d-none d-md-block" />
        <img src="/img/images/testimonial_shape04.png" alt="" className="shape-4 d-none d-lg-block" />
      </div>
    </section>
  );
};

export default ClientsTalk;